import { render, staticRenderFns } from "./viewvisits.vue?vue&type=template&id=93ddeb42&"
import script from "./viewvisits.vue?vue&type=script&lang=js&"
export * from "./viewvisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports